/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:45:12
 * @LastEditors: lkz
 * @LastEditTime: 2021-07-21 14:51:21
 */

/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/workOrderManagement',
    name: '/workOrderManagement',
    meta: {
      title: '工单配置'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderConfig/LimitList.vue')
  }, {
    path: '/workOrderManagement/workOrderLimit',
    name: '/workOrderManagement/workOrderLimit',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderConfig/LimitConfig.vue')
  }, {
    path: '/workOrderManagement/workOrderProcess/workOrderProcessList',
    name: '/workOrderProcessList',
    meta: {
      title: '工单流程配置'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderProcess/workOrderProcessList.vue')
  }, {
    path: '/workOrderManagement/workOrderProcess/workOrderProcessDetails',
    name: '/workOrderProcessDetails',
    meta: {
      title: '工单流程详情页'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderProcess/workOrderProcessDetails.vue')
  }, {
    path: '/workOrderManagement/allWorkOrder/allWorkOrderList',
    name: '/allWorkOrderList',
    meta: {
      title: '全部工单'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/allWorkOrder/allWorkOrderNew.vue')
  }, {
    path: '/workOrderManagement/allWorkOrder/workOrderDetail',
    name: '/workOrderDetail',
    meta: {
      title: '工单详情'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/allWorkOrder/workOrderDetail.vue')
  }, {
    path: '/workOrderManagement/workOrderTemplate/workOrderTemplateList',
    name: '/workOrderTemplateList',
    meta: {
      title: '工单模板'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderTemplate/workOrderTemplateList.vue')
  }, {
    path: '/workOrderManagement/workOrderAttribute',
    name: '/workOrderAttribute',
    meta: {
      title: '工单配置'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderAttribute/AttributeList.vue')
  }, {
    path: '/workOrderManagement/workOrderViewport/workOrderViewportList',
    name: '/workOrderViewportList',
    meta: {
      title: '工单配置'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderViewport/workOrderViewportList.vue')
  }, {
    path: '/workOrderManagement/workOrderAttribute/attributeConfig',
    name: '/attributeConfig',
    meta: {
      title: '工单配置'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderAttribute/AttributeConfig.vue')
  }, {
    path: '/workOrderManagement/workOrderReason/reasonConfig',
    name: '/reasonConfig',
    meta: {
      title: '工单原因'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/workOrderReason/reasonConfig.vue')
  },
  {
    path: '/workOrderManagement/createWorkOrder',
    name: '/createWorkOrder',
    meta: {
      title: '创建工单'
    },
    component: () => import(/* webpackChunkName: "example-workOrderManagement" */ '../views/workOrderManagement/allWorkOrder/createWorkOrder.vue')
  },
  {
    path: '/workOrderManagement/batchHandle',
    name: '/batchHandle',
    meta: {
      title: '批量处理'
    },
    component: () => import(/* webpackChunkName: "xinyunweb-workOrderManagement" */ '../views/workOrderManagement/batchHandle/index.vue')
  },
  {
    path: '/workOrderManagement/errorWorkOrder',
    name: '/errorWorkOrder',
    meta: {
      title: '异常工单列表'
    },
    component: () => import(/* webpackChunkName: "xinyunweb-workOrderManagement" */ '../views/workOrderManagement/errorWorkOrder/index.vue')
  }
]
